/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-children-prop */
import {
  Flex,
  FormControl,
  FormControlProps,
  FormErrorMessage,
  FormLabel,
  Select
} from "@chakra-ui/react";
import { Control, Controller, FieldError, FieldValues, Path } from "react-hook-form";
import { IconType } from "react-icons";
import { TextGray } from "../../Texts/TextGray";

interface Options {
  value: string;
  label: string;
}

export interface InputSelectProps<T extends FieldValues> extends FormControlProps {
  name: Path<T>;
  label?: string;
  icon?: IconType;
  error?: FieldError;
  isLoading?: boolean;
  option: Options[];
  control: Control<T>;
  onOptionChange?: (value: string) => void;
}

export const InputSelect = <T extends FieldValues>({
  name,
  label,
  error,
  isLoading = false,
  icon: IconComponent,
  control,
  option,
  ...rest
}: InputSelectProps<T>) => {
  return (
    <FormControl {...rest} isInvalid={!!error}>
      {!!label && (
        <FormLabel htmlFor={name} fontSize="sm">
          <Flex alignItems="center">
            {IconComponent && (
              <TextGray as="span" mr="1.5">
                <IconComponent />
              </TextGray>
            )}
            {label}
          </Flex>
        </FormLabel>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Select {...field} disabled={isLoading} onChange={(evt) => {
            field.onChange(evt);
            rest.onOptionChange?.(evt.target.value);
          }}>
            <option value="">Selecione um valor</option>
            {option.map((x) => (
              <option key={x.value} value={x.value}>
                {x.label}
              </option>
            ))}
          </Select>
        )}
      />
      {!!error && (
        <FormErrorMessage mt="1" fontSize="xs">
          {error.message}
        </FormErrorMessage>
      )}
    </FormControl>
  );
};
